export default __webpack_public_path__ + "static/media/sb_404.790ccfff.svg";